import { render, staticRenderFns } from "./im-dialog.vue?vue&type=template&id=32f4f7bd&scoped=true"
import script from "./im-dialog.vue?vue&type=script&lang=js"
export * from "./im-dialog.vue?vue&type=script&lang=js"
import style0 from "./im-dialog.vue?vue&type=style&index=0&id=32f4f7bd&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32f4f7bd",
  null
  
)

export default component.exports